import { questionsContent } from "./questions";
import { bodyContent } from "./body";

export const faqViewContent = {
  questionsContent,
  bodyContent,
};
